import OticonHeader from './header';
(function () {
  var header = new OticonHeader('#header', '#content', '#footer');
  header.run();
})();